import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-kanban',
  name: 'Access Kanban',
  category: 'access-integrations',
  description: 'Manage kanban boards, columns, tasks, comments, and tags in Access Kanban',
  icon: 'Columns',
  color: 'blue',
  version: '1.0.0',

  defaults: {
    name: 'Access Kanban',
    color: '#3b82f6'
  },

  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'kanban', 'boards', 'tasks', 'project-management'],

  toolCapable: {
    enabled: true,
    name: 'access_kanban',
    description: 'Manage kanban boards, columns, tasks, comments, and tags in Access Kanban project management system',
    allowManualDescription: false,
    parameters: {
      resource: {
        toolParamName: 'resource',
        description: 'The resource type: board, column, task, comment, or tag',
        required: true,
        type: 'string',
      },
      action: {
        toolParamName: 'action',
        description: 'The operation to perform on the resource',
        required: true,
        type: 'string',
      },
      boardId: {
        toolParamName: 'boardId',
        description: 'The board ID (required for board-specific operations)',
        required: false,
        type: 'string',
      },
      taskId: {
        toolParamName: 'taskId',
        description: 'The task ID (required for task operations)',
        required: false,
        type: 'string',
      },
      columnId: {
        toolParamName: 'columnId',
        description: 'The column ID (required for column operations)',
        required: false,
        type: 'string',
      },
      targetColumnId: {
        toolParamName: 'targetColumnId',
        description: 'Target column ID for moving tasks',
        required: false,
        type: 'string',
      },
      tagId: {
        toolParamName: 'tagId',
        description: 'The tag ID (required for delete tag operation)',
        required: false,
        type: 'string',
      },
      body: {
        toolParamName: 'body',
        description: 'JSON body for create/update operations',
        required: false,
        type: 'string',
      },
      environment: {
        toolParamName: 'environment',
        description: 'The environment: preprod or production',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      statusCode: 'HTTP status code',
      action: 'The action performed',
      data: 'The response data (boards, columns, tasks, comments, or tags)',
    },
  },
};

export default definition;
